import React from 'react';

type Props = {
  property: any;
}

export default function PropertyLocationMap({ property }: Props) {
  return (
    <div
      className="rounded"
      data-controller="googleMap"
      data-googlemap-options-value={JSON.stringify({ center: { lat: property.latitude, lng: property.longitude } })}
      data-googlemap-polygon-value={property.parcelBoundary ? JSON.stringify(property.parcelBoundary) : JSON.stringify([])}
      data-googlemap-property-type-id-value={property.propertyTypeId}
      style={{ height: 350 }}
    />
  );
}
